/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { CreateSolicitorOrganizationDto } from '../models/CreateSolicitorOrganizationDto';
import type { SolicitorOrganizationDto } from '../models/SolicitorOrganizationDto';
import type { UpdateSolicitorOrganizationDto } from '../models/UpdateSolicitorOrganizationDto';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SolicitorOrganizationsService {
    constructor(public readonly http: HttpClient) {}
    /**
     * Create a solicitor organization
     * @param requestBody
     * @returns SolicitorOrganizationDto The solicitor organization has been created.
     * @throws ApiError
     */
    public solicitorOrganizationsControllerCreate(
        requestBody: CreateSolicitorOrganizationDto,
    ): Observable<SolicitorOrganizationDto> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/solicitor-organizations',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * List solicitor organizations
     * @param filter
     * @param includeInactive
     * @returns SolicitorOrganizationDto List of solicitor organizations.
     * @throws ApiError
     */
    public solicitorOrganizationsControllerList(
        filter?: string,
        includeInactive?: boolean,
    ): Observable<Array<SolicitorOrganizationDto>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitor-organizations',
            query: {
                'filter': filter,
                'includeInactive': includeInactive,
            },
        });
    }
    /**
     * Get a solicitor organization by ID
     * @param id
     * @returns SolicitorOrganizationDto The solicitor organization details.
     * @throws ApiError
     */
    public solicitorOrganizationsControllerGetById(
        id: string,
    ): Observable<SolicitorOrganizationDto> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/solicitor-organizations/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a solicitor organization
     * @param id
     * @param requestBody
     * @returns SolicitorOrganizationDto The solicitor organization has been updated.
     * @throws ApiError
     */
    public solicitorOrganizationsControllerUpdate(
        id: string,
        requestBody: UpdateSolicitorOrganizationDto,
    ): Observable<SolicitorOrganizationDto> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/solicitor-organizations/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
